const {
  REACT_APP_ROUTE_PATH_MAIN,
  REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS,
  REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_AL04_TRABAJOS,
  REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_PRELIQUIDAR,
  REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_DOCHP,
  REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_MO
} = process.env

const SCHEMA: string = 'Procesos'
const ENTITY: string = 'Trabajos'
const ROUTE_PROGRAMADOS: string = `/${REACT_APP_ROUTE_PATH_MAIN}/${REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS}`
const ROUTE_TRABAJOS: string = `${ROUTE_PROGRAMADOS}/${REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_AL04_TRABAJOS}`
const ROUTE_PRELIQUIDAR: string = `${ROUTE_TRABAJOS}/${REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_PRELIQUIDAR}`
const ROUTE_DOCHP: string = `${ROUTE_TRABAJOS}/${REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_DOCHP}`
const ROUTE_MO: string = `${ROUTE_TRABAJOS}/${REACT_APP_ROUTE_PATH_MAIN_PROGRAMADOS_DE_TRABAJOS_MO}`
const SELECT_TRABAJOS: string = '/SigoPwa/Programados/Gestion/Trabajos/Select'

export const AdapterConfigure = {
  SCHEMA,
  ENTITY,
  SELECT_TRABAJOS,
  ROUTE_PROGRAMADOS,
  ROUTE_TRABAJOS,
  ROUTE_PRELIQUIDAR,
  ROUTE_DOCHP,
  ROUTE_MO
}